import { CommonConst } from "@constants/common-const";

export const DesignCellComponent = ({ data }: any, accessType: string) => {
  const customerName = data.data.customerName ? `, ${data.data.customerName}` : "";
  const customerMobileNumber = data.data.customerMobileNumber ? `/ ${data.data.customerMobileNumber}` : "";
  const totalPrice = data.data.estimate?.totalPrice ? `, ${data.data.estimate.totalPrice.toLocaleString()}원` : "";
  const handleClick = (data: any) => {
    if (accessType === CommonConst.ACCESS_TYPE_ADMIN) {
      window.open(`/admin/company/${data.companyId}/design/detail/${data.id}`);
    } else {
      window.open(`/design/detail/${data.id}`);
    }
  };

  return (
    <a className="cursor-pointer hover:underline text-[#007bff]" onClick={() => handleClick(data.data)}>
      {data.data.id
        ? `${data.data.id}, ${data.data.title} ${customerName} ${customerMobileNumber} ${totalPrice}`
        : null}
    </a>
  );
};
